// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/insights.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { EnableProjectInsightsRequest, EnableProjectInsightsResponse, GetCoAuthorStatsRequest, GetCoAuthorStatsResponse, GetProjectInsightsStatusRequest, GetProjectInsightsStatusResponse, ReportCoAuthorStatsRequest, ReportCoAuthorStatsResponse } from "./insights_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * InsightsService provides AI code attribution analytics for projects.
 * The CLI reports per-commit co-author data from git history, and the
 * dashboard reads aggregated stats.
 *
 * @generated from service gitpod.v1.InsightsService
 */
export const InsightsService = {
  typeName: "gitpod.v1.InsightsService",
  methods: {
    /**
     * Reports co-author analysis results from a project's git history.
     * Accepts a batch of per-commit stats. Writes are idempotent: re-reporting
     * the same commit (project_id + commit_hash) overwrites the previous row.
     *
     * @generated from rpc gitpod.v1.InsightsService.ReportCoAuthorStats
     */
    reportCoAuthorStats: {
      name: "ReportCoAuthorStats",
      I: ReportCoAuthorStatsRequest,
      O: ReportCoAuthorStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns aggregated co-author stats for a project within a date range.
     *
     * Aggregates per-commit data into summary cards (totals per tool) and
     * time-series buckets at the requested resolution.
     *
     * @generated from rpc gitpod.v1.InsightsService.GetCoAuthorStats
     */
    getCoAuthorStats: {
      name: "GetCoAuthorStats",
      I: GetCoAuthorStatsRequest,
      O: GetCoAuthorStatsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Enables co-author insights for a project. Idempotent.
     *
     * @generated from rpc gitpod.v1.InsightsService.EnableProjectInsights
     */
    enableProjectInsights: {
      name: "EnableProjectInsights",
      I: EnableProjectInsightsRequest,
      O: EnableProjectInsightsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns whether co-author insights is enabled for a project.
     *
     * @generated from rpc gitpod.v1.InsightsService.GetProjectInsightsStatus
     */
    getProjectInsightsStatus: {
      name: "GetProjectInsightsStatus",
      I: GetProjectInsightsStatusRequest,
      O: GetProjectInsightsStatusResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

